import { useTranslation } from "react-i18next";

import { useAllDevices } from "../hooks/use-devices";
import { useActiveIncidents } from "../hooks/use-incidents";
import { ErrorScreenWithText } from "../partials/error-screen";
import { LoadingScreenWithText } from "../partials/loading-screen";
import { PagePartial } from "../partials/page-partial";
import { Workplace } from "../partials/workplace";

export const WorkplacesPage = () => {
  const { t } = useTranslation();

  const { devices, error, isLoading } = useAllDevices();
  const { incidents = [] } = useActiveIncidents();

  if (isLoading) return <LoadingScreenWithText />;

  if (error) return <ErrorScreenWithText error={error} />;

  return (
    <PagePartial title={t("page.workplaces")}>
      <Workplace devices={devices} incidents={incidents} />
    </PagePartial>
  );
};
